<template>
  <div id="extend-session" class="editor-modal" >
    <form @submit.stop.prevent >
        <h2 v-html="title"></h2>
        <p class="text-muted" v-html="description"></p>
        <div class="footer">
          <div v-if="showSavingOptions" class="actions">
              <button class="btn btn-primary" @click="saveChanges" :disabled="changesSaved">{{$t('expired.save')}}</button>
              <button class="btn btn-secondary" @click="trashChanges">{{$t('expired.trash')}}</button>
          </div> 
          <router-link v-else @click.native="$emit('close')" class="btn btn-primary" :to="{ name: 'settings.subscription'}">{{$t('expired.browse')}}</router-link>
        </div>
    </form>
  </div>
</template>

<script>
export default {
data () {
    return {
      changesSaved: false
    }
},
props: {
  title: String,
  description: String,
  onCancel: Function,
  confirmButtonText: String,
  showSavingOptions: Boolean
},
methods: {
  saveChanges(){
      this.$store.dispatch('saveTemplateChanges').then(() => { 
        this.changesSaved = true
        this.$router.push("/settings/subscription")
        this.$emit('close')
      })
  },
  trashChanges(){
     this.$store.state.unsavedChanges = false;
     this.$router.push("/settings/subscription")
     this.$emit('close')
  }
}

};
</script>

<style lang="less">
#extend-session form{
  padding: 30px 25px 25px 25px;
  flex-direction: column;
  h2 {
    margin: 0;
    margin-right: 15px;
  }
  .text-muted {
    margin: 0;
  }
  .username{
      margin: 0;
      margin-top: 10px;
      font-size: 14px;
      color: #495057;
      font-weight: 500; 
      opacity: .7;
      border: none;
  }
  .third-option{
    margin: 0 25px;
}
  .footer {
    margin-top: 10px;
  }
}
</style>
